<template>
    <div class="sports_item_detail sports_register_detail">
      <Form :list="itemDetail.registerform" :buttonColor="buttonColor" @submit="submit" :statement="itemDetail.statement" :userinfo="userInfo"/>
      <div style="height: 2rem;">&nbsp;</div>
      <!-- <div class="sese">请参照示范视频角度及动作，正面/侧面拍摄动作，保证动作标准性，以便系统识别计分，谢谢</div> -->
    </div>
</template>

<script>
    import Footbar from '@/components/footbar/index'
    import Form from '@/components/form/index.vue'

    import {Empty, Panel, Cell, Button, CellGroup,Checkbox, CheckboxGroup, Field,Popup,Picker} from 'vant';
    import "./index.less"
    export default {
        computed: {
            buttonColor() {
                return `#0598D6`;
            }
        },
        components: {
            Empty,
            Panel,
            Cell,
            Button,
            CellGroup,
            Footbar,
            Form,
            Field,
            Checkbox,
            CheckboxGroup,Popup,Picker
        },
        data() {
            return {
                detail: '',
                itemDetail: "",
                item_sub_id: '',
                acid: '',
                userInfo: {},
                district: '',
                showpicker: false
            }
        },
        methods: {
            submit: function (e) {
                this.$dialog.confirm({
                    title: "提示",
                    confirmButtonText: '确定提交',
                    message: '信息提交后不可修改,确定提交?',
                    showCancelButton: true
                }).then(() => {
                    let query = {
                        cpgid: this.item_sub_id, 
                        registerInfo: e
                    }
                    this.$api.sports.submitCompare(query).then((res) => {
                        if (+res.status === 200) {
                          this.$router.replace({ name: 'sportsResult', params:this.$route.params})
                        }
                    })

                    // on confirm
                }).catch(() => {
                    // on cancel
                });


                console.log(e)
            },
            init: function () {
                this.$toast.loading({
                    duration: 0
                });
                let params = {cpgid: this.item_sub_id}
                this.$api.sports.getComparegame(params).then((res) => {
                    if (res.data.registerform) {
                        try {
                            res.data.registerform = JSON.parse(res.data.registerform);
                        } catch (e) {
                            console.log(e)
                        }
                    }
                    this.itemDetail = res.data
                    this.$toast.clear();
                })
            },
            gores() {
                this.$router.replace({ name: 'sportsResult', params:this.$route.params})
            },
        },
        mounted() {
            this.item_sub_id = this.$route.params.item_sub_id
            this.acid = this.$route.params.acid
            this.$api.user.getUserInfo().then((res) => {
                if (res.status * 1 === 200) {
                    this.userInfo = res.data;
                    this.init();
                }
            });
        }

    }
</script>
